import { render, staticRenderFns } from "./RedeemInvitation.vue?vue&type=template&id=e246b65e&scoped=true&"
import script from "./RedeemInvitation.vue?vue&type=script&lang=ts&"
export * from "./RedeemInvitation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e246b65e",
  null
  
)

export default component.exports